/** Dedicated manage route — companion full page; desktop keeps the sheet. */
export function displayManagePath(
  screenId: string,
  options?: { playContent?: boolean },
): string {
  const base = `/screens/${encodeURIComponent(screenId)}`;
  if (!options?.playContent) return base;
  return `${base}?play=1`;
}

export function displayManageSearchPath(
  screenId: string,
  options?: { playContent?: boolean },
): string {
  const params = new URLSearchParams({ manage: screenId });
  if (options?.playContent) params.set('play', '1');
  return `/screens?${params.toString()}`;
}

export function isDisplayManagePath(pathname: string): boolean {
  return /^\/screens\/[^/]+$/.test(pathname);
}
